"use strict";

exports.__esModule = true;
exports.HistoricalPartCountEditDialog = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Core = require("../../../Core");
var _icons = require("@blueprintjs/icons");
var _TimeContext = require("../../../Time/TimeContext");
var _FormattedPlantDate = require("../../../Time/FormattedPlantDate/FormattedPlantDate");
var _PartCountSelector = require("./PartCountSelector");
var _vimanaTypes = require("@vimana/vimana-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var DialogBodySection = _styledComponents["default"].div.withConfig({
  displayName: "HistoricalPartCountEditDialog__DialogBodySection",
  componentId: "sc-1qfxbq-0"
})(["margin:1rem 1rem 0 1rem;"]);
var PartCountDialog = (0, _styledComponents["default"])(_core.Dialog).withConfig({
  displayName: "HistoricalPartCountEditDialog__PartCountDialog",
  componentId: "sc-1qfxbq-1"
})([".", "{border-top:1px solid rgba(0,0,0,0.1);padding-top:1rem;}"], _core.Classes.DIALOG_FOOTER);
var HistoricalPartCountEditDialog = exports.HistoricalPartCountEditDialog = function HistoricalPartCountEditDialog(props) {
  var theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  var translator = (0, _react.useContext)(_Core.TranslatorContext);
  var _useContext = (0, _react.useContext)(_TimeContext.TimeContext),
    timezone = _useContext.timezone;
  var values = props.values,
    show = props.show,
    showPartInstanceInfo = props.showPartInstanceInfo,
    closeButton = props.closeButton,
    submitButton = props.submitButton,
    confirm = props.confirm;
  var _useState = (0, _react.useState)(values.goodPartCount),
    goodPartCount = _useState[0],
    setGoodPartCount = _useState[1];
  var _useState2 = (0, _react.useState)(values.badPartCount),
    badPartCount = _useState2[0],
    setBadPartCount = _useState2[1];
  (0, _react.useEffect)(function () {
    setGoodPartCount(values.goodPartCount);
    setBadPartCount(values.badPartCount);
  }, [values]);
  var translate = translator.translate;
  return /*#__PURE__*/_react["default"].createElement(PartCountDialog, {
    icon: _icons.IconNames.COG,
    className: theme.bodyClassName,
    isOpen: show,
    onClose: function onClose() {
      setGoodPartCount(values.goodPartCount);
      setBadPartCount(values.badPartCount);
      closeButton();
    },
    title: translate("HistoricalPartCountDialog.title", "Edit Part Count")
  }, /*#__PURE__*/_react["default"].createElement(DialogBodySection, null, /*#__PURE__*/_react["default"].createElement(_PartCountSelector.Part, {
    "data-testid": "HistoricalPartCountDialog.shift.label"
  }, translate("HistoricalPartCountDialog.shift.label", "Shift: " + (values.shift || ""))), /*#__PURE__*/_react["default"].createElement(_PartCountSelector.Part, {
    "data-testid": "HistoricalPartCountDialog.partKind.label"
  }, translate("HistoricalPartCountDialog.partKind.label", "Part Kind: " + (values.partKind || ""))), /*#__PURE__*/_react["default"].createElement(_PartCountSelector.Part, {
    "data-testid": "HistoricalPartCountDialog.partProcess.label"
  }, translate("HistoricalPartCountDialog.partProcess.label", "Part Process: " + (values.partProcess || ""))), showPartInstanceInfo ? /*#__PURE__*/_react["default"].createElement(_PartCountSelector.Part, {
    "data-testid": "HistoricalPartCountDialog.partInstance.label"
  }, translate("HistoricalPartCountDialog.partInstance.label", "Part Instance: " + (values.partInstance || ""))) : null, /*#__PURE__*/_react["default"].createElement("p", {
    "data-testid": "HistoricalPartCountDialog.timestampStart.label"
  }, values != null && values.timestampStart ? translate("HistoricalPartCountDialog.timestampStart.label", "Start time: " + (0, _FormattedPlantDate.formatDateString)(values.timestampStart, Object.assign({}, _FormattedPlantDate.DATE_PRESETS.LongDateTime, {
    timeZone: timezone.name
  }))) : null), /*#__PURE__*/_react["default"].createElement("p", {
    "data-testid": "HistoricalPartCountDialog.timestampEnd.label"
  }, values != null && values.timestampEnd ? translate("HistoricalPartCountDialog.timestampEnd.label", "End time: " + (0, _FormattedPlantDate.formatDateString)(values.timestampEnd, Object.assign({}, _FormattedPlantDate.DATE_PRESETS.LongDateTime, {
    timeZone: timezone.name
  }))) : null), /*#__PURE__*/_react["default"].createElement(_PartCountSelector.PartCountSelector, {
    goodPartCount: goodPartCount != null ? goodPartCount : values.goodPartCount,
    badPartCount: badPartCount != null ? badPartCount : values.badPartCount,
    setGoodPartCount: setGoodPartCount,
    setBadPartCount: setBadPartCount
  })), /*#__PURE__*/_react["default"].createElement("footer", {
    className: _core.Classes.DIALOG_FOOTER
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.DIALOG_FOOTER_ACTIONS
  }, /*#__PURE__*/_react["default"].createElement(_Core.ActionButton, {
    intent: _core.Intent.PRIMARY,
    "data-testid": "HistoricalPartCountDialog.submit.button",
    onClick: function onClick() {
      return submitButton(goodPartCount, badPartCount);
    },
    text: translate("HistoricalPartCountDialog.submit.button", "Save"),
    confirm: confirm
  }))));
};